export enum CourseCategory {
  PSYCHOLOGY = 'psychology',
  BUSINESS_ENGLISH = 'business-english',
  DIGITAL_MARKETING = 'digital-marketing',
  DESIGN_THINKING = 'design-thinking',
  SOCIAL_MEDIA = 'social-media',
  CAREER_DEVELOPMENT = 'career-development',
}

export enum CourseLevel {
  SHORT_COURSE = 'short-course',
  HNC = 'hnc',
  HND = 'hnd',
  BACHELOR = 'bachelor',
  MASTERS = 'masters',
  LEVEL_3 = 'level-3',
  LEVEL_4 = 'level-4',
  LEVEL_5 = 'level-5',
  LEVEL_6 = 'level-6',
  LEVEL_7 = 'level-7',
}

export const COURSE_LEVEL_LABELS: Record<CourseLevel, string> = {
  [CourseLevel.SHORT_COURSE]: 'Short Course',
  [CourseLevel.HNC]: 'HNC',
  [CourseLevel.HND]: 'HND',
  [CourseLevel.BACHELOR]: 'Bachelor',
  [CourseLevel.MASTERS]: 'Masters',
  [CourseLevel.LEVEL_3]: 'Level 3',
  [CourseLevel.LEVEL_4]: 'Level 4',
  [CourseLevel.LEVEL_5]: 'Level 5',
  [CourseLevel.LEVEL_6]: 'Level 6',
  [CourseLevel.LEVEL_7]: 'Level 7',
};

export enum CourseType {
  MASTERS_DEGREE = 'masters-degree',
  PRE_MASTERS_DEGREE = 'pre-masters-degree',
  BACHELORS_DEGREE = 'bachelors-degree',
  OTHM = 'othm',
  SHORT = 'short',
}

export const COURSE_TYPE_LABELS: Record<CourseType, string> = {
  [CourseType.MASTERS_DEGREE]: "Master's Degree",
  [CourseType.PRE_MASTERS_DEGREE]: "Pre-Master's Degree",
  [CourseType.BACHELORS_DEGREE]: "Bachelor's Degree",
  [CourseType.OTHM]: 'OTHM',
  [CourseType.SHORT]: 'Short Course',
};

export const DEGREE_COURSE_TYPES: readonly CourseType[] = [
  CourseType.MASTERS_DEGREE,
  CourseType.PRE_MASTERS_DEGREE,
  CourseType.BACHELORS_DEGREE,
];

export const isDegreeCourseType = (type?: string | null) =>
  DEGREE_COURSE_TYPES.includes(type as CourseType);

export const isDegreeLikeCourseType = (type?: string | null) =>
  isDegreeCourseType(type) || type === CourseType.OTHM;

export const COURSE_CATEGORY_LABELS: Record<CourseCategory, string> = {
  [CourseCategory.PSYCHOLOGY]: 'Psychology',
  [CourseCategory.BUSINESS_ENGLISH]: 'Business English',
  [CourseCategory.DIGITAL_MARKETING]: 'Digital Marketing',
  [CourseCategory.DESIGN_THINKING]: 'Design Thinking',
  [CourseCategory.SOCIAL_MEDIA]: 'Social Media',
  [CourseCategory.CAREER_DEVELOPMENT]: 'Career Development',
};

export enum CoursePathway {
  CAREER_PROGRESSION = 'career-progression',
  CAREER_CHANGE = 'career-change',
  UPSKILLING = 'upskilling',
}

export const COURSE_PATHWAY_LABELS: Record<CoursePathway, string> = {
  [CoursePathway.CAREER_PROGRESSION]: 'Career progression',
  [CoursePathway.CAREER_CHANGE]: 'Career change',
  [CoursePathway.UPSKILLING]: 'Upskilling',
};

export enum StudyFormat {
  ONLINE = 'online',
  OFFLINE = 'offline',
  BLENDED = 'blended',
}

export const STUDY_FORMAT_LABELS: Record<StudyFormat, string> = {
  [StudyFormat.ONLINE]: 'Online',
  [StudyFormat.OFFLINE]: 'Offline',
  [StudyFormat.BLENDED]: 'Blended',
};

export enum StudyMode {
  FULL_TIME = 'full-time',
  PART_TIME = 'part-time',
}

export const STUDY_MODE_LABELS: Record<StudyMode, string> = {
  [StudyMode.FULL_TIME]: 'Full-time',
  [StudyMode.PART_TIME]: 'Part-time',
};
